module.exports = __webpack_public_path__ + "img/logo-bei-white.ffc593af.svg";